import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateRange.scss";
import { ReactComponent as Calendar } from "../../assets/svg/calendar.svg";
import { useSelector } from "react-redux";
import { setFromDate, setToDate } from "../../redux/slice/filterSlice";
import RootState from "../../redux/types/rootState";
import Button from "@mui/material/Button";
import { Clear } from "@mui/icons-material";
import { fetchBookings } from "../../redux/slice/bookingSlice";
import { useAppDispatch } from "../../redux/dispatch/useAppDispatch";

const getDefaultStartDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 15); // 15 days ago
  return date;
};

const getDefaultEndDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 4); // 4 days from now
  return date;
};

const DateRangePicker = () => {
  const searchFilter = useSelector(
    (booking: RootState) => booking.searchFilter
  );
  const { fromDate: startDateF, toDate: endDateF } = searchFilter;
  const [startDate, setStartDate] = useState<Date | null>(startDateF || getDefaultStartDate());
  const [endDate, setEndDate] = useState<Date | null>(endDateF || getDefaultEndDate());
  const dispatch = useAppDispatch();

  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    dispatch(setFromDate(null));
    dispatch(setToDate(null));
    dispatch(fetchBookings({ page: 1 }));
  };

  useEffect(() => {
    dispatch(setFromDate(startDate));
    if (startDate) {
      dispatch(fetchBookings({ page: 1 }));
    }
  }, [startDate]);

  useEffect(() => {
    dispatch(setToDate(endDate));
    if (endDate) {
      dispatch(fetchBookings({ page: 1 }));
    }
  }, [endDate]);

  return (
    <>
      <DatePicker
        className="DatePickerStartDate DatePickerNotMUI"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        selectsStart
        placeholderText="From"
        startDate={startDate}
        endDate={endDate}
        showIcon={true}
        icon={<Calendar className="CalendarIcon" />}
        calendarIconClassname="CalendarIcon"
        dateFormat="dd/MM/yyyy"
      />
      <DatePicker
        className="DatePickerEndDate DatePickerNotMUI"
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        icon={<Calendar className="CalendarIcon" />}
        showIcon={true}
        placeholderText="To"
        calendarIconClassname="CalendarIcon"
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        dateFormat="dd/MM/yyyy"
      />
      {startDate && endDate ? (
        <Button
          className="clearDatesButton"
          variant="contained"
          onClick={handleClearDates}
        >
          <Clear />
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};
export default DateRangePicker;
